//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { BikeRepairStationLargeSVG } from './svg'

interface BikeRepairStationLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const BikeRepairStationLargeIcon: React.FC<BikeRepairStationLargeIconProps> = forwardRef<
  BikeRepairStationLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={BikeRepairStationLargeSVG}
    sx={sx}
  />
))
